import { TweenMax } from 'gsap';
import {state} from './state';
// import {wheel} from './wheel';
import {windowSize} from './windowSize';
// import { Tween } from 'gsap/gsap-core';
// import {whalehandle} from './whalehandle';

let inviewSet = {
  inview: $(".js-inview"),
  ellipse: $(".ell-item"),
  isShow: "is-show",
  posArray:[],
  inviewState:[],
  heightAdjustValue: 0.76,
};

export const inview={
  inview:()=>{
    for (let i=0,li=inviewSet.posArray.length;i<li;i++) {
      let scl=-state.freeScrollPos;
      let elTop=inviewSet.posArray[i];
      if (scl + windowSize.clientSize().H*inviewSet.heightAdjustValue > elTop) {
        if (inviewSet.inview.eq(i).hasClass(inviewSet.isShow)) continue;
          inviewSet.inview.eq(i).addClass(inviewSet.isShow);
          // TweenMax.to(inviewSet.inview.eq(i),.8,{opacity:1});
      }
    }
    inview.ellipseMotion();
  },
  stackItemsPosition:()=>{
    for(let i=0,li=inviewSet.inview.length;i<li;i++){
      inviewSet.posArray.push(inviewSet.inview.eq(i).offset().top);
    }
  },
  ellipseMotion:()=>{
    TweenMax.set(inviewSet.ellipse, { y:-state.freeScrollPos*0.3});
  },
  // restorePosition:()=>{

  // },
};